import React from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, Shield, Zap, Heart } from 'lucide-react';

export function Hero() {
    return (
        <section className="relative bg-sp-dark text-white overflow-hidden pt-16 pb-12 px-4 sm:pt-20 sm:pb-16">
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10">
                <div className="flex-1 text-center md:text-left">
                    <span className="inline-block bg-white/20 backdrop-blur-sm px-4 py-1 rounded-full text-sm font-bold mb-4">
                        🐾 Sin pilas · Sin suscripción · Para siempre
                    </span>
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-black leading-tight">
                        Protegé a tu mascota <br />
                        <span className="text-sp-pink">como nunca antes</span>
                    </h1>
                    <p className="text-white/80 text-base sm:text-lg font-semibold mt-3 md:mt-4 max-w-2xl mx-auto md:mx-0">
                        No vendemos chapitas. Vendemos tranquilidad eterna.
                        Un ecosistema digital que te avisa al instante si alguien encuentra a tu amigo,
                        sin depender de un número mal marcado.
                    </p>
                    <div className="flex flex-wrap gap-3 sm:gap-4 justify-center md:justify-start mt-5 md:mt-6">
                        <Link
                            to="/comprar"
                            className="bg-sp-cta hover:bg-sp-cta-hover text-white font-bold px-6 sm:px-8 py-2.5 sm:py-3 rounded-full shadow-lg transition flex items-center gap-2 text-sm sm:text-base"
                        >
                            <Shield size={18} className="sm:w-5 sm:h-5" /> Comprar ahora
                        </Link>
                        <a
                            href="#como-funciona"
                            className="bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white font-bold px-5 sm:px-6 py-2.5 sm:py-3 rounded-full transition flex items-center gap-2 text-sm sm:text-base"
                        >
                            <Smartphone size={18} className="sm:w-5 sm:h-5" /> Ver demo
                        </a>
                    </div>
                    <div className="flex flex-wrap gap-3 sm:gap-6 mt-5 sm:mt-8 text-xs sm:text-sm text-white/70 justify-center md:justify-start">
                        <span className="flex items-center gap-1"><Heart size={14} className="sm:w-4 sm:h-4 text-sp-pink" /> 100% a prueba de errores</span>
                        <span className="flex items-center gap-1"><Zap size={14} className="sm:w-4 sm:h-4 text-sp-pink" /> Notificación en tiempo real</span>
                        <span className="flex items-center gap-1"><Shield size={14} className="sm:w-4 sm:h-4 text-sp-pink" /> Sin mensualidad</span>
                    </div>
                </div>
                <div className="hidden md:block flex-1 flex justify-center">
                    <div className="relative w-48 h-48 sm:w-56 sm:h-56 lg:w-80 lg:h-80">
                        <img
                            src="./icono.png"
                            alt="SmartPet chapita"
                            className="w-full h-full object-contain drop-shadow-2xl"
                        />
                        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent rounded-full blur-2xl" />
                    </div>
                </div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 h-8 sm:h-12 bg-sp-light" style={{ clipPath: 'ellipse(60% 100% at 50% 100%)' }} />
        </section>
    );
}